const BRANDING_THEME_KEY = "brandingTheme";
const BRANDING_IMAGE_KEY = "imageFileName";

const BrandingService = {
  getBrandingTheme: () => {
    const theme = localStorage.getItem(BRANDING_THEME_KEY);
    return theme ? JSON.parse(theme) : null;
  },

  setBrandingTheme: (theme) => {
    localStorage.setItem(BRANDING_THEME_KEY, JSON.stringify(theme));
  },

  clearBrandingTheme: () => {
    localStorage.removeItem(BRANDING_THEME_KEY);
  },

  getImage: () => {
    return localStorage.getItem(BRANDING_IMAGE_KEY) || "";
  },

  setImage: (url) => {
    localStorage.setItem(BRANDING_IMAGE_KEY, url);
  },

  clearImage: () => {
    localStorage.removeItem(BRANDING_IMAGE_KEY);
  },

  clearAll: () => {
    BrandingService.clearBrandingTheme();
    BrandingService.clearImage();
  }
};

export default BrandingService;
